import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const IconButton = ({ icon: Icon, onClick, tooltip }) => (
  <button
    onClick={onClick}
    className="p-2 hover:bg-gray-100 rounded-full relative group focus:outline-none focus:ring-2 focus:ring-blue-600"
    aria-label={tooltip}
  >
    <Icon className="w-5 h-5 text-gray-600" />
    {tooltip && (
      <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
        {tooltip}
      </span>
    )}
  </button>
);

IconButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
};

export default React.memo(IconButton);
